export default __webpack_public_path__ + "static/media/fbshare.8db17ddf.jpg";